<template>
  <div class="OddsRow-styles-odds-row Category-styles-event-details-row" >
    <div class="OddsRow-styles-info-cell" :class="(Object.values(odd.odd).length === 2) ? ' OddsRow-styles-w50' : ' OddsRow-styles-w25'">
      <span :class="(odd.transIt) ? '' : 'notranslate'">{{ odd.name }}</span>
    </div>
    <div class="OddsRow-styles-odd-group-cell">
      <SelectionButton v-for="selection in sortAByKey(odd.odd, 'order')"
                 :class="(findByKey(selectedOdds, 'oddId', selection.id)) ? 'active' : 'disable' "
                 :selectedOdds="selectedOdds" :odd.sync="selection" :match="match" :market="odd">

      </SelectionButton>
    </div>
  </div>


</template>

<script>
    import SelectionButton from "../../selectionButton";
    export default {
        name: "row",
        props: ['odd', 'match', 'selectedOdds'],
        components: {SelectionButton}
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/market/template/row.vue